import React, { useState } from "react";
import Col from "../Flex/Col";
import Row from "../Flex/Row";
import Field from "./Shared/Field";
import Input from "./Shared/Input";
function DateInput(props) {
    const { label, readOnly = false, inline = false, onChange, error, rows = false, autoComplete = "off", override = {}, } = props;
    const [day, month, year] = props.value || ["", "", ""];
    const display = day || month || year ? `${day}.${month}.${year}` : "";
    const hasValue = Boolean(display);
    const [isFocused, setFocus] = useState(false);
    const [dayRef, monthRef, yearRef, inputRef, inputTogglerRef] = [
        React.createRef(),
        React.createRef(),
        React.createRef(),
        React.createRef(),
        React.createRef(),
    ];
    function openInput(e) {
        if (props.onFocus)
            props.onFocus(e);
        setFocus(true);
        if (inputTogglerRef && inputTogglerRef.current)
            inputTogglerRef.current.style.display = "block";
        if (dayRef.current && monthRef.current && yearRef.current)
            if (!day)
                dayRef.current.focus();
            else if (!month)
                monthRef.current.focus();
            else
                yearRef.current.focus();
    }
    function closeInput(e) {
        if (e &&
            e.relatedTarget !== dayRef.current &&
            e.relatedTarget !== monthRef.current &&
            e.relatedTarget !== yearRef.current) {
            setFocus(false);
            if (props.onBlur)
                props.onBlur(e);
        }
    }
    const hasError = Boolean(error);
    return (React.createElement(Field, { label: props.label, readOnly: props.readOnly, open: props.open, inline: props.inline, hasValue: hasValue, info: props.info, error: props.error, isFocused: isFocused, autoComplete: props.autoComplete, onClick: props.onClick, onFocus: props.onFocus, onBlur: props.onBlur, override: props.override, hideLabel: inline && isFocused, onLabelClick: () => {
            openInput();
        } },
        !isFocused && (React.createElement(Input, { label: label, readOnly: readOnly, inline: inline, autoComplete: autoComplete, value: display, onChange: () => { }, type: "text", setFocus: () => { }, hasError: hasError, rows: rows, onClick: props.onClick, onFocus: openInput, onBlur: () => { }, inputRef: inputRef, suggestions: props.suggestions, onSuggestionSelect: props.onSuggestionSelect, override: override })),
        React.createElement("div", { style: { display: isFocused ? "block" : "none" }, ref: inputTogglerRef },
            React.createElement(Row, { spacing: 16, root: 0, parts: 8 },
                React.createElement(Col, { xs: 2 },
                    React.createElement(Input, { label: label + "-DD", placeholder: "DD", readOnly: readOnly, inline: inline, value: day, autoComplete: autoComplete, onChange: (value) => {
                            if (!readOnly && onChange) {
                                if (!value || value.length < 3)
                                    return onChange([value || "", month, year]);
                                if (monthRef.current)
                                    monthRef.current.focus();
                                onChange([day, !value ? "" : value.slice(-1), year]);
                            }
                        }, type: "text", setFocus: () => { }, hasError: hasError, rows: rows, onClick: props.onClick, onFocus: () => { }, onBlur: closeInput, inputRef: dayRef, override: override })),
                React.createElement(Col, { xs: 2 },
                    React.createElement(Input, { label: label + "-MM", placeholder: "MM", readOnly: readOnly, inline: inline, value: month, autoComplete: autoComplete, onChange: (value) => {
                            if (!readOnly && onChange) {
                                if (!value || value.length < 3) {
                                    if (!value && dayRef.current)
                                        dayRef.current.focus();
                                    return onChange([day, value || "", year]);
                                }
                                if (yearRef.current)
                                    yearRef.current.focus();
                                onChange([day, month, !value ? "" : value.slice(-1)]);
                            }
                        }, type: "text", setFocus: () => { }, hasError: hasError, rows: rows, onClick: props.onClick, onFocus: () => { }, onBlur: closeInput, inputRef: monthRef, override: override })),
                React.createElement(Col, { xs: 4 },
                    React.createElement(Input, { label: label + "-YY", placeholder: "YY", readOnly: readOnly, inline: inline, value: year, autoComplete: autoComplete, onChange: (value) => {
                            if (!readOnly && onChange) {
                                if (!value || value.length < 5) {
                                    if (!value && monthRef.current)
                                        monthRef.current.focus();
                                    return onChange([day, month, value || ""]);
                                }
                                onChange([day, month, year]);
                            }
                        }, type: "text", setFocus: () => { }, hasError: hasError, rows: rows, onClick: props.onClick, onFocus: () => { }, onBlur: closeInput, inputRef: yearRef, override: override }))))));
}
export default DateInput;
